export default __webpack_public_path__ + "static/quick-guide-c0d316c6d85009cf65acfa5cf8d63c29.mp4";